import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import axios from 'axios';
import { Btn, H5 } from '../AbstractElements';
import config from '../config';
import CustomizerContext from '../_helper/Customizer';
import EgoalIcon from '../assets/images/logo/egoallogo.png';
import persistSession from './persistSession';
import { messageForSsoError } from './ssoErrors';

// Where Microsoft sign-in lands. Either it carries a one-time hand-off code to
// swap for a session, or an error code to explain why it could not.
const SsoCallback = () => {
    const [searchParams] = useSearchParams();
    const history = useNavigate();
    const { layoutURL } = useContext(CustomizerContext);
    const [errorMessage, setErrorMessage] = useState(null);

    // The code is single use and React StrictMode double-mounts effects in
    // development, so without this guard the second run redeems a spent code
    // and shows a phantom failure.
    const redeemed = useRef(false);

    useEffect(() => {
        if (redeemed.current) return;
        redeemed.current = true;

        const errorCode = searchParams.get('error');
        if (errorCode) {
            setErrorMessage(messageForSsoError(errorCode));
            return;
        }

        const handoffCode = searchParams.get('c');
        if (!handoffCode) {
            setErrorMessage(messageForSsoError('SSO_INVALID_CODE'));
            return;
        }

        axios.post(`${config.hostname}/auth/microsoft/exchange`, { c: handoffCode })
            .then((response) => {
                // The same writer the password form uses, so an SSO session is
                // indistinguishable from a password one.
                persistSession(response.data, history, layoutURL);
            })
            .catch((error) => {
                const code = error.response && error.response.data && error.response.data.ssoCode;
                setErrorMessage(messageForSsoError(code));
            });
    }, []);

    return (
        <Fragment>
            <Container fluid={true} className="p-0">
                <Row className="m-0">
                    <Col className="p-0">
                        <div className="login-card">
                            <div className="login-main" style={{ textAlign: 'center' }}>
                                <img
                                    className="img-fluid for-light mb-4"
                                    src={EgoalIcon}
                                    alt="EGoal"
                                    style={{ maxWidth: '220px' }}
                                />
                                {errorMessage ? (
                                    <Card className="shadow-none">
                                        <CardBody>
                                            <H5>Could not sign you in</H5>
                                            <p className="f-14 f-light mt-2 mb-4">{errorMessage}</p>
                                            <Btn attrBtn={{
                                                color: 'primary',
                                                onClick: () => history(`${process.env.PUBLIC_URL}/login`)
                                            }}>Back to sign in</Btn>
                                        </CardBody>
                                    </Card>
                                ) : (
                                    <p className="f-14 f-light">Signing you in...</p>
                                )}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default SsoCallback;
